import React, { useState } from "react";
import imgRight from "./img/83EB37A4-BC1A-45A9-B4BB-0A685DDBD989.webp";
import "./style.css";

const faqData = [
  {
    question: "Рассрочка шарттары:",
    answer: [
      "Банк аркылуу бөлүп төлөө",
      "Паспорт талап кылынат",
      "100,000 сомдон жогору сумма үчүн поручитель керек",
    ],
  },
  {
    question: "Биздин дүкөндөрүбүз:",
    answer: [
      "Беш-Сары соода борбору, 1-кабат, Бишкек, Кыргызстан.",
      "Кулатова көчөсү 2, “Стройпак” соода борбору, 3-кабат, Бишкек, Кыргызстан"
    ]
  },
  {
    question: "Жеткирүү:",
    answer: [
      "Бишкек боюнча жеткирүү бекер.",
      "Аймактарга жеткирүү кошумча төлөм менен.",
    ],
  },
  {
    question: "Заказ берүү:",
    answer:
      "Ватсап аркылуу тандаган столуңуздун жана стулдарыңыздын сүрөтүн жиберип коюңуз. Биз баасын эсептеп, төлөмдү кантип жасай турганыбызды сүйлөшөбүз.",
  },
];

function HeaderDown() {
  const [openIndex, setOpenIndex] = useState(null);

  return (
    <section className="relative py-20 md:py-32 bg-gradient-to-b from-gray-50 to-white overflow-hidden">
      {/* Фоновая текстура / градиент */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_30%_20%,rgba(161,195,73,0.06),transparent_50%)]" />

      <div className="relative max-w-6xl mx-auto px-5 sm:px-8 lg:px-12">
        {/* Видео-блок */}
        <div className="mb-16 md:mb-24">
          <h3 className="
            text-3xl sm:text-4xl md:text-5xl font-extrabold 
            bg-gradient-to-r from-gray-900 via-[#A1C349] to-gray-900 
            bg-clip-text text-transparent text-center mb-8
          ">
            Биздин иш жана сапат кандай экенин көрүңүз
          </h3>

          <div className="
            relative w-full aspect-video rounded-2xl overflow-hidden 
            shadow-2xl border border-gray-200/50
          ">
            <iframe
              className="absolute inset-0 w-full h-full"
              src="https://www.youtube.com/embed/u8y0XtKEsec?si=YyrVJpEwREPPbkMU"
              title="AJAR MEBEL — столдор жана стулдар"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerPolicy="strict-origin-when-cross-origin"
              allowFullScreen
            ></iframe>
          </div>
        </div>

        {/* FAQ блок */}
        <div className="max-w-7xl mx-auto">
          <h2 className="
            text-3xl sm:text-4xl md:text-5xl font-extrabold 
            bg-gradient-to-r from-gray-900 via-[#A1C349] to-gray-900 
            bg-clip-text text-transparent text-center mb-12
          ">
            Көп берилүүчү суроолор
          </h2>

          <div className="space-y-4">
            {faqData.map((item, index) => {
              const isOpen = openIndex === index;
              return (
                <div
                  key={index}
                  className={`
                    rounded-2xl overflow-hidden border border-gray-200/80
                    bg-white/90 backdrop-blur-sm shadow-sm
                    hover:shadow-md transition-all duration-300
                    ${isOpen ? "border-[#A1C349]/40 shadow-lg" : ""}
                  `}
                >
                  <button
                    onClick={() => setOpenIndex(isOpen ? null : index)}
                    className="w-full px-6 py-5 flex items-center justify-between text-left"
                  >
                    <div className="flex items-center gap-4">
                      <div
                        className={`
                          w-9 h-9 rounded-lg flex items-center justify-center text-xl
                          transition-colors ${isOpen ? "bg-[#A1C349] text-white" : "bg-gray-100 text-gray-600 group-hover:bg-[#A1C349]/10"}
                        `}
                      >
                        <ion-icon name="help-circle-outline" />
                      </div>
                      <span
                        className={`
                          text-lg font-semibold transition-colors
                          ${isOpen ? "text-[#A1C349]" : "text-gray-900 group-hover:text-[#A1C349]"}
                        `}
                      >
                        {item.question}
                      </span>
                    </div>

                    <ion-icon
                      name="chevron-down-outline"
                      className={`text-2xl transition-transform duration-400 ${isOpen ? "rotate-180 text-[#A1C349]" : "text-gray-400"}`}
                    />
                  </button>

                  <div
                    className={`
                      overflow-hidden transition-all duration-500
                      ${isOpen ? "max-h-96 py-6 px-6" : "max-h-0"}
                    `}
                  >
                    <div className="pl-12 space-y-2.5 text-gray-700">
                      {Array.isArray(item.answer) ? (
                        item.answer.map((line, i) => (
                          <p key={i} className="text-base font-medium">
                            • {line}
                          </p>
                        ))
                      ) : (
                        <p className="text-base font-medium">{item.answer}</p>
                      )}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>

          <p className="text-center mt-12 text-gray-500 text-base italic">
            Жооп таппай жатасызбы? Жазыңыз — 5 мүнөттө жооп беребиз
          </p>
        </div>
      </div>
    </section>
  );
}

export default HeaderDown;